import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'

import BuyerDetails, {BuyerDetailsProps} from './BuyerDetails'

import {selectSellerTradePartnersCount} from '../../../../data/seller-trade-partners'
import {PRE_UNDERWRITING_COMPANY_FINANCIALS} from '../constants'
import {ROUTE_INTRO} from '../../../../routes/constants'
import {aShowBuyerForm, selectIsBuyerFormVisible} from './store/view'

const mapStateToProps = (
  state: Record<string, any>
): Pick<BuyerDetailsProps, 'hasBuyers' | 'isBuyerFormVisible'> => ({
  hasBuyers: selectSellerTradePartnersCount(state) > 0,
  isBuyerFormVisible: selectIsBuyerFormVisible(state),
})

const mapDispatchToProps = {
  showBuyerForm: aShowBuyerForm,
  redirectToCompanyFinancials: (): any =>
    aPush(ROUTE_INTRO, {page: PRE_UNDERWRITING_COMPANY_FINANCIALS}),
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerDetails)
